import { RootState } from '../../../Store/index';

export const selectExceptionData = (state: RootState) => state.ExceptionReducer.exceptionData;